import React, {useState} from 'react';
import {Field} from './MembersShared.tsx';
import banks from './membersBanks.json';
import {digits} from './membersInputFormats.ts';

// Snapshot BrasilAPI /api/banks/v1, 14/09/2026. Apenas instituições com código COMPE.
const searchable = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export default function MembersBankField({value, onChange}: {value: string; onChange: (value: string) => void}) {
  const [query, setQuery] = useState('');
  const [manual, setManual] = useState(false);
  const known = banks.some(bank => bank.code === value);
  const other = manual || (!!value && !known);
  const filtered = banks.filter(bank => bank.code === value || searchable(`${bank.code} ${bank.name}`).includes(searchable(query.trim())));
  return <div className="space-y-4">
    <Field label="Buscar banco por nome ou código" value={query} onChange={event => setQuery(event.target.value)} placeholder="Ex.: Banco do Brasil ou 001" type="search" />
    <label className="block space-y-2 text-sm">
      <span className="font-medium">Banco *</span>
      <select className="members-input w-full min-w-0 text-sm" name="bank_selection" value={other ? 'other' : value} required onChange={event => {
        const selected = event.target.value;
        setManual(selected === 'other');
        setQuery('');
        onChange(selected === 'other' ? '' : selected);
      }}>
        <option value="">Selecione o banco</option>
        {filtered.map(bank => <option key={bank.code} value={bank.code}>{bank.code} — {bank.name}</option>)}
        <option value="other">Outros — informar código</option>
      </select>
    </label>
    {query && !banks.some(bank => searchable(`${bank.code} ${bank.name}`).includes(searchable(query.trim()))) && <p className="members-secondary text-sm" role="status">Banco não encontrado. Selecione “Outros — informar código”.</p>}
    {other && <Field label="Código do banco" name="bank_code" value={value} onChange={event => onChange(digits(event.target.value).slice(0, 3))} inputMode="numeric" pattern="[0-9]{3}" minLength={3} maxLength={3} placeholder="000" required />}
  </div>;
}
